import SubFooterComponent from "../../components/SubFooterComponent";
import ProgressContainer from "./ProgressContainer";
import { Container, TopContainer } from "./styled";

const HomeContainer = () => {
    return (
        <Container>
            <TopContainer>
                <ProgressContainer />
            </TopContainer>
            <SubFooterComponent />
        </Container>
    );
};

export default HomeContainer;